import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateContainerQrRedirectCampaignByIdMutationVariables = Types.Exact<{
  id: Types.Scalars['Int'];
  container_qr_redirects: Types.CreateContainerQrRedirectionCampaignByContainerTypeInput;
}>;


export type UpdateContainerQrRedirectCampaignByIdMutation = { __typename?: 'Mutation', updateContainerQrRedirectCampaignById?: { __typename?: 'ContainerQrRedirectionCampaign', id: number, container_type_id: number, redirect_url: string, start_date: string, end_date: string, visit_count: number, forward_container_short_id?: boolean | null } | null };


export const UpdateContainerQrRedirectCampaignByIdDocument = gql`
    mutation updateContainerQrRedirectCampaignById($id: Int!, $container_qr_redirects: CreateContainerQrRedirectionCampaignByContainerTypeInput!) {
  updateContainerQrRedirectCampaignById(
    id: $id
    container_qr_redirects: $container_qr_redirects
  ) {
    id
    container_type_id
    redirect_url
    start_date
    end_date
    visit_count
    forward_container_short_id
  }
}
    `;
export type UpdateContainerQrRedirectCampaignByIdMutationFn = Apollo.MutationFunction<UpdateContainerQrRedirectCampaignByIdMutation, UpdateContainerQrRedirectCampaignByIdMutationVariables>;

/**
 * __useUpdateContainerQrRedirectCampaignByIdMutation__
 *
 * To run a mutation, you first call `useUpdateContainerQrRedirectCampaignByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContainerQrRedirectCampaignByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContainerQrRedirectCampaignByIdMutation, { data, loading, error }] = useUpdateContainerQrRedirectCampaignByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      container_qr_redirects: // value for 'container_qr_redirects'
 *   },
 * });
 */
export function useUpdateContainerQrRedirectCampaignByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContainerQrRedirectCampaignByIdMutation, UpdateContainerQrRedirectCampaignByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContainerQrRedirectCampaignByIdMutation, UpdateContainerQrRedirectCampaignByIdMutationVariables>(UpdateContainerQrRedirectCampaignByIdDocument, options);
      }
export type UpdateContainerQrRedirectCampaignByIdMutationHookResult = ReturnType<typeof useUpdateContainerQrRedirectCampaignByIdMutation>;
export type UpdateContainerQrRedirectCampaignByIdMutationResult = Apollo.MutationResult<UpdateContainerQrRedirectCampaignByIdMutation>;
export type UpdateContainerQrRedirectCampaignByIdMutationOptions = Apollo.BaseMutationOptions<UpdateContainerQrRedirectCampaignByIdMutation, UpdateContainerQrRedirectCampaignByIdMutationVariables>;